import { SESSION_ERRORS } from '@constants';
import { setToken } from './auth';

export const tokenMiddleware = ({ dispatch }) => (next) => (action) => {
  if (SESSION_ERRORS.includes(action?.error?.message)) {
    dispatch(setToken(''));
  }
  return next(action);
};
